import React, {Fragment, useContext, useEffect, useState} from 'react';
import FormSection from 'components/sales/formSection/formSectionNew';
import localization from 'assets/localization/localization';
// import Regex from 'services/utils/regex/Regex';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import {FormGroup} from 'react-bootstrap';
import TimePicker from 'react-times';
import 'react-times/css/classic/default.css';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import {DatePickerInput} from 'rc-datepicker';
// import DatePicker from 'components/sales/datePicker/datePicker';
// import FileUpload from 'components/sales/fileUpload/fileUpload';
import {toast, ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
// import ReactTooltip from "react-tooltip";
import {handleValidateObj} from 'constants/objValues/objvalues';
import {getChallansList} from "../../../services/redux/installation/hardwareInstall/action";
import {BaseUrl} from "../../../contexts/baseUrl/baseUrl";
import TableSection from "../../../components/sales/tableSection/tableSection";
import Layout from 'components/sales/layout/layout';

const MaterialReceiving = ({
                             handleValue,
                             leadInfraId,
                             documentUploadUrl,
                             documentUrlData,
                             getLeadInfraId,
                             prefilledData,
                             getChallansList,
                             challansList,
                           }) => {

  const {baseUrl} = useContext(BaseUrl);
  const [inputList, setInputList] = useState([{name: "", image_url: "", position: ""}]);
  const [infraId, setInfraId] = useState(0);
  const [projectName, setProjectName] = useState();
  const [infraIdToCheck, setInfraIdToCheck] = useState(null);
  const [siteNumber, setSiteNumber] = useState(null);
  const [createdBy, setCreatedBy] = useState(null);
  const [services, setServices] = useState();
  const [listData, setListData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const Headers = [
    'MRF No.',
    'Site No.',
    'Business Name',
    'Challan Number',
    'Date',
    'Created By',
    'Status',
    'Completed Date',
    'Actions',
  ];

  useEffect(() => {
    (async () => {
      setIsLoading(true);
        let res = await getChallansList(infraIdToCheck,siteNumber,createdBy,1);
        if (res?.resultSets) {
        }
      setIsLoading(false);
      })();
  },[])

  useEffect(() => {
    const tableData = [
      'id',
      'mrf_id',
      'site_no',
      'client_name',
      'challan_id',
      'created_at',
      'username',
      'status',
      'completed_at'
    ];
    if (challansList) {

      const data =
        challansList?.resultSets?.length &&
        challansList.resultSets.map((element) =>
          Object.assign(
            {},
            ...tableData.map((key) => (
              {[key]: element[key]})),
              (element['status'] !== 'Completed') ?
              {
                Action:
                  [
                    /*{
                      name: 'View Details',
                      link: `${baseUrl}/brand-activation/carnival/details`,
                    },*/
                    {
                      name: 'Receive Material',
                      link: `${baseUrl}/receive-material`,
                    }
                  ]
              }
              :
                {
                  Action:
                    [{
                      name: 'View Details',
                      link: `${baseUrl}/brand-activation/carnival/details`,
                    }]
                }
          )
        );
        console.log(challansList?.resultSets?.length);
      if (challansList?.resultSets?.length && data) {
        setListData(data);
        setPageCount(Math.ceil(challansList.total / challansList.per_page));
        setCurrentPage(challansList.current_page);
      } else {
        setListData([]);
       
          // toast.error('No data found!');
      }
    }
  }, [challansList, baseUrl]);

  /*const handleMeetingData = () => {
    if (
      formData.services?.length > 0 &&
      formData.start_date !== '' &&
      formData.end_date !== '' &&
      formData.start_time !== '' &&
      formData.end_time !== '' &&
      formData.subject !== ''
    ) {
      handleValue({...formData, members: inputList, infra_id: infraId});
    } else handleValue(null);
  };
  useEffect(() => {
    handleMeetingData();
  }, [formData, inputList]);*/

  const checkInfraId = (infra_id) => {
    setListData([]);
    (async () => {
    setIsLoading(true);
      let res = await getChallansList((infraIdToCheck !== undefined) ? infraIdToCheck : 0,siteNumber,createdBy,1);
      if (res?.resultSets) {
      }
    setIsLoading(false);
    })();
  };

  const onPageChange = async (val) => {
    setIsLoading(true);
    await getChallansList(infraIdToCheck,siteNumber,createdBy,val.selected + 1, filterData);
    setIsLoading(false);
};

  return (
    <Layout
      // isGoback
      title={localization.tsList}
      isLoading={isLoading}
      linkFlag
      linkUrl={`${baseUrl}/brand-activation/sites-listing`}
    >
    <FormSection title={localization.tsList}>
      <div className="row mb-5">
        <div className="col-md-3 col-sm-12">
          <ConstantInput
            label={localization.enterMrf}
            value={infraId !== 0 ? infraId : null}
            handleChange={(value) => setInfraIdToCheck(value)}
            type="number"
          />
        </div>
        <div className="col-md-3 col-sm-12">
          <ConstantInput
            label={localization.siteNumber}
            value={siteNumber !== 0 ? siteNumber : null}
            handleChange={(value) => setSiteNumber(value)}
            type="text"
          />
        </div>
        <div className="col-md-3 col-sm-12">
          <ConstantInput
            label={localization.createdBy}
            value={createdBy !== 0 ? createdBy : null}
            handleChange={(value) => setCreatedBy(value)}
            type="text"
          />
        </div>
        
        <div className="col-md-2 col-sm-5">
          <button className="btn btn-sm btn-primary" onClick={checkInfraId}>Check</button>
        </div>

      </div>

      {challansList?.resultSets?.length > 0 && (
        <>
          <TableSection
            data={listData}
            headers={Headers}
            detailList={challansList?.resultSets}
            isId={false}
            pageCount={pageCount}
            onPageChange={onPageChange}
            srNo={challansList?.from}
            currentPage={currentPage}
          />

        </>
      )}

    </FormSection>
    </Layout>
  );
};

MaterialReceiving.propTypes = {};

export default MaterialReceiving;
